/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { Row } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { FaFileInvoice } from "react-icons/fa";
import { InvoiceItemsModal } from "../modal/invoice-items";

interface DataTableRowActionsProps {
  row: Row<any>;
}

export function DataTableRowActions({
  row,
}: DataTableRowActionsProps) {
  const { handleModal } = useDialogModal();
  const handleOpenModal = () => {
    handleModal({
      isOpen: true,
      element:
        <InvoiceItemsModal id={row.original.id as any}
        />,
      title: "Visualizar Itens da Nota",
    });
  };

  return (
    <div className="flex gap-2 py-2 items-center justify-center">
      <Button className="p-3" variant={"outline"} onClick={handleOpenModal}>
        <FaFileInvoice className="h-4 w-4" />
      </Button>
    </div>
  );
}
